import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axiosInstance from "../utils/axiosInstance";
import "../styles/ResetPasswordPage.css";

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  // URL: /reset-password/:uid/:token  (senin router’ın böyleyse)
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8) errors.push(t("resetPassword.validation.minLength"));
    if (!/[A-Z]/.test(password)) errors.push(t("resetPassword.validation.uppercase"));
    if (!/[a-z]/.test(password)) errors.push(t("resetPassword.validation.lowercase"));
    if (!/[0-9]/.test(password)) errors.push(t("resetPassword.validation.digit"));
    if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password)) errors.push(t("resetPassword.validation.specialChar"));
    return errors;
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    // URL param kontrolü (link bozuksa)
    if (!uid || !token) {
      setErrorMessage(t("resetPassword.invalidLink"));
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage(t("resetPassword.passwordMismatch"));
      return;
    }

    const validationErrors = validatePassword(newPassword);
    if (validationErrors.length > 0) {
      setPasswordErrors(validationErrors);
      return;
    }

    try {
      setLoading(true);

      await axiosInstance.post("/api/auth/password-reset/confirm/", {
        uidb64: uid,           // backend uidb64 bekliyor
        token: token,
        new_password: newPassword,
      });

      setSuccessMessage(t("resetPassword.successMessage"));
      setTimeout(() => navigate("/login"), 1500);
    } catch (error) {
      console.error("Şifre sıfırlama hatası:", error);
      const msg =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        t("resetPassword.genericError");
      setErrorMessage(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2 className="auth-title">{t("resetPassword.title")}</h2>

        {errorMessage && (
          <div className="position-alert alert-danger">{errorMessage}</div>
        )}

        {passwordErrors.length > 0 && (
          <ul className="password-error-list">
            {passwordErrors.map((err, index) => (
              <li key={index}>{err}</li>
            ))}
          </ul>
        )}

        {successMessage && (
          <div className="position-alert alert-success">{successMessage}</div>
        )}

        <form className="auth-form" onSubmit={handleReset}>
          <label>{t("resetPassword.newPassword")}</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => {
              const v = e.target.value;
              setNewPassword(v);
              setPasswordErrors(validatePassword(v));
            }}
            required
            disabled={loading}
          />

          <label>{t("resetPassword.newPasswordConfirm")}</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            disabled={loading}
          />

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? t("resetPassword.submitting") : t("resetPassword.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
